import React from 'react';
import ExpenseBoard from '../components/ExpenseComps/ExpenseBoard';

const CONFIG = {
    noun: 'Daily',
    categories: ['Travel', 'Food', 'Fuel', 'Stationery', 'Office Supplies', 'Miscellaneous'],
    trackStatus: true,
    reminders: true,
};

export { CONFIG as DAILY_CONFIG };

export default function DailyExpensesPage({ data }) {
    return <ExpenseBoard config={CONFIG} data={data} />;
}
